<template>
  <v-container>
    <v-row class="wrap d-flex justify-center align-content-center fill-height">
      <v-col cols="col-md-12 col-lg-6">
        <v-card class="pa-2">
          <v-form ref="form">
            <v-card-title class="deep-orange--text darken-3">S'inscrire</v-card-title>
            <v-card-text>
              <v-text-field 
                v-model="email"
                :rules="emailRules"
                label="Email"
                required
                color="deep-orange darken-3"
              ></v-text-field>

              <v-text-field
                v-model="password"
                :rules="passwordRules"
                label="Mot de passe"
                required
                :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :type="passwordShow ? 'text' : 'password'"
                @click:append="passwordShow = !passwordShow"
                lazy-validation
                 color="deep-orange darken-3"
              ></v-text-field>

              <v-text-field
                v-model="confirmPassword"
                label="Confirmez le mot de passe"
                :rules="[passwordConfirmationRule]"
                lazy-validation
                required
                :append-icon="confirmPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :type="confirmPasswordShow ? 'text' : 'password'"
                @click:append="confirmPasswordShow = !confirmPasswordShow"
                color="deep-orange darken-3"
              ></v-text-field>
              <v-alert
                color="red"
                dense
                v-if="error"
                :dismissible="true"
              >
                {{ getError(error) }}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn color="deep-orange darken-3 white--text" @click="validate" @keypress.enter="validate" :loading="loading">S'inscrire</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    passwordShow: false,
    confirmPasswordShow: false,
    email: "",
    emailRules: [
      v => !!v || "E-mail est requis",
      v => /.+@.+/.test(v) || "E-mail doit être valide"
    ],
    password: "",
    confirmPassword: "",
    passwordRules: [v => !!v || "Mot de passe ou confirmation sont erronés"]
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.registerWithFirebase();
      }
    },
    registerWithFirebase() {
      const user = {
        email: this.email,
        password: this.password
      };
      this.$store
        .dispatch("signUpAction", user)
        .then( () => this.$router.replace('/account'))
    },
    getError(error) {
      const firebaseErrors = {
        'auth/user-not-found': 'Aucun utilisateur trouvé',
        'auth/email-already-in-use': 'L\'email est déjà utilisé',
        'auth/weak-password': 'Le mot de passe doit contenir au moins 6 lettres ou chiffres'
      }
      let m = firebaseErrors[error.code] || error.message
      return m
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      error: 'error',
      loading: 'loading'
    }),
    passwordConfirmationRule() {
      if (this.password !== this.confirmPassword) {
        return 'Les mots de passe ne sont pas cohérents'
      } else if (this.confirmPasswordShow == '') {
        return 'Vous devez confirmer le mot de passe'
      } else {
        return true
      }
    },
  }
};
</script>